import { render, staticRenderFns } from "./SettingsTabsV2026.vue?vue&type=template&id=0d6e3210&scoped=true"
import script from "./SettingsTabsV2026.vue?vue&type=script&lang=js"
export * from "./SettingsTabsV2026.vue?vue&type=script&lang=js"
import style0 from "./SettingsTabsV2026.vue?vue&type=style&index=0&id=0d6e3210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6e3210",
  null
  
)

export default component.exports